/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Checkbox,
  // Checkbox,
  Chip,
  FormControlLabel,
  // FormControlLabel,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@material-ui/core";
import { NavigateBefore } from "@material-ui/icons";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { Save } from "react-feather";
import { useTranslation } from "react-i18next";
import { HPOTerms } from ".";
import { checkFile } from "./dropZone";

const useStyles = makeStyles((theme) => ({
  chip: {
    "& span": {
      color: `${theme.palette.text.primary} !important`,
    },
  },
}));

function Nanaopore({
  directory,
  setPhase,
  // setFormData,
  files,
  fileMeta,
  setFileMeta,
  fileActionType,
  appConf,
}) {
  const isInputFormatValid = () => true;

  const isFileConfigUnique = () => true;

  const [formData, setFormData] = useState([]);

  const classes = useStyles();

  // const setFileMetaPromise = () =>
  //   new Promise(async (resolve, reject) => {
  //     let tmpFileMeta = [];
  //     for (let i = 0; i < directory.length; i++) {
  //       let item = directory[i];
  //       let folder = {};
  //       folder = {
  //         ...folder,
  //         file_name: getFileCellValues(item["name"]),
  //       };
  //       for (let j = 0; j < Object.values(formData[i]).length; j++) {
  //         let formItem = Object.values(formData[i])[j];
  //         let formName = Object.keys(formData[i])[j];
  //         folder = {
  //           ...folder,
  //           [formName]: formItem[formName],
  //         };
  //       }
  //       tmpFileMeta.push(folder);
  //       if (i === tableView.length - 1) {
  //         resolve(tmpFileMeta);
  //       }
  //     }
  //     // setFileMeta(tmpFileMeta);
  //   });

  const handleChange = (event, index) => {
    setFormData({
      ...formData,
      [index]: {
        ...formData[index],
        [event.target.name]: Number(event.target.value)
          ? Number(event.target.value)
          : event.target.value,
      },
    });
  };

  const handleCheckbox = (event, index) => {
    setFormData({
      ...formData,
      [index]: {
        ...formData[index],
        [event.target.name]: event.target.checked,
      },
    });
  };

  // const handleCheckbox = (event, index) => {
  //   setFormData({
  //     ...formData,
  //     [index]: {
  //       ...formData[index],
  //       [event.target.name]: event.target.checked,
  //     },
  //   });
  // };

  const { enqueueSnackbar } = useSnackbar();

  const { t } = useTranslation();

  const handleSubmit = async (event) => {
    event.preventDefault();
    let data = [];
    await directory.map(async (value, index) => {
      const totalSize = files.reduce((sum, file) => sum + file.byte_size, 0);

      let tmpformData = {
        filename: value.item ? value.item.fullPath : value.path,
        byte_size: totalSize,
        trim_min_len: formData[index]["trim_min_len"] || 100,
      };
      await Object.entries(formData[index]).forEach((item) => {
        tmpformData = { ...tmpformData, [item[0]]: item[1] };
      });
      // tmpformData["calculate_frequency"] = true;
      data.push(tmpformData);
    });

    if (directory.length <= 0) {
      await files.map(async (value, index) => {
        let tmpformData = {
          filename: `${value.name}`,
        };
        await Object.entries(formData[index]).forEach((item) => {
          tmpformData = { ...tmpformData, [item[0]]: item[1] };
        });
        data.push(tmpformData);
      });
    }

    setFileMeta(data);
    if (isInputFormatValid()) {
      if (isFileConfigUnique()) {
        setPhase("credit_calculate");
      } else {
        enqueueSnackbar(
          t(
            "form_conf_not_unique_message",
            "Form configuration is not unique. Please check and try again."
          ),
          {
            variant: "error",
          }
        );
      }
    } else {
      enqueueSnackbar(
        t(
          "form_input_not_valid_message",
          "Form input are not valid. Please check and try again."
        ),
        {
          variant: "error",
        }
      );
    }
  };

  const newPromise = () =>
    new Promise((resolve, reject) => {
      let newTableView = {};
      let folderNames = [];
      directory.forEach((val, index) => {
        let item = val.item;
        if (fileActionType === "upload") {
          if (val.isUploaded) {
            folderNames = {
              ...folderNames,
              [index]: {
                ...folderNames[index],
                barcode_code: item["name"],
                sample_name: item["name"],
                trim_min_len: 100,
                calculate_frequency: true,
              },
            };
            item.createReader().readEntries((entries) => {
              newTableView = {
                ...newTableView,
                [item["name"]]: entries.filter((item) =>
                  checkFile(item.name, "nanopore")
                ),
              };
              if (Object.keys(newTableView).length === directory.length) {
                resolve([newTableView, folderNames]);
              }
            });
          }
        } else {
          newTableView = { ...newTableView, [val.name]: val };
          folderNames = {
            ...folderNames,
            [index]: {
              ...folderNames[index],
              barcode_code: val["name"],
              sample_name:
                val["name"].split("/")[val["name"].split("/").length - 1],
              trim_min_len: 100,
              calculate_frequency: true,
            },
          };
        }
      });
      if (
        Object.keys(newTableView).length === directory.length &&
        Object.keys(newTableView).length !== 0
      ) {
        resolve([newTableView, folderNames]);
      }
    });

  const [tableView, setTableView] = useState([]);

  useEffect(() => {
    if (directory.length <= 0) {
      let data = [];
      files.forEach((value) => {
        data.push({
          barcode_code: value.name.split(".")[0],
          sample_name: value.name.split(".")[0],
          trim_min_len: 100,
          calculate_frequency: true,
        });
      });
      setFormData(data);
    }
  }, []);
  useEffect(() => {
    newPromise().then((result) => {
      setTableView({ ...result[0] });
      setFormData(result[1]);
    });
  }, []);

  const handleHPOTermsChange = (name, value, index) => {
    const updatedFormData = {
      ...formData,
      [index]: {
        ...formData[index],
        [name]: value,
      },
    };
    setFormData(updatedFormData);
  };

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: "15%" }}>{t("Barcode")}</TableCell>
            <TableCell style={{ width: "15%" }}>{t("Sample Name")}</TableCell>
            <TableCell style={{ width: "15%" }}>
              {t("Minimum Length")}
            </TableCell>
            <TableCell>{t("File Names")}</TableCell>
            <TableCell style={{ width: "15%" }}>{t("HPO Terms")}</TableCell>
            <TableCell style={{ textAlign: "center" }}>
              {t("Variant Frequency Calculation")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(directory.length > 0 ? directory : files).map((item, index) => {
            return (
              <TableRow key={index}>
                <TableCell style={{ padding: "0 5px" }}>
                  <TextField
                    label={t("Barcode Code")}
                    // name={"barcode_code"}
                    variant="outlined"
                    type="text"
                    disabled
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={
                      formData[index]?.barcode_code
                        ? formData[index]?.barcode_code
                        : item.name
                    }
                    defaultValue={
                      formData[index]?.barcode_code
                        ? formData[index]?.barcode_code
                        : item.name
                    }
                    // onChange={(e) => handleChange(e, index)}
                    style={{ width: "100%", margin: "0 5px 0 0" }}
                  />
                </TableCell>
                <TableCell style={{ padding: "0 5px" }}>
                  <TextField
                    variant="outlined"
                    label={t("Sample Name")}
                    name={"sample_name"}
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => handleChange(e, index)}
                    value={
                      formData[index]?.sample_name
                        ? formData[index]?.sample_name
                        : item.name
                    }
                    defaultValue={
                      formData[index]?.sample_name
                        ? formData[index]?.sample_name
                        : item.name
                    }
                    style={{ width: "100%", margin: "0 5px 0 0" }}
                  />
                </TableCell>
                <TableCell style={{ padding: "0 5px" }}>
                  <TextField
                    label={t("Minimum Length")}
                    name={"trim_min_len"}
                    type="number"
                    onChange={(e) => handleChange(e, index)}
                    defaultValue={100}
                    value={formData[index]?.trim_min_len ?? item.trim_min_len}
                    style={{ width: "100%", margin: "0 5px 0 0" }}
                  />
                </TableCell>
                <TableCell style={{ padding: "10px 0" }}>
                  <Box
                    maxWidth={500}
                    maxHeight={200}
                    style={{
                      overflowY: "scroll",
                      margin: 0,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "2px",
                      padding: "8px",
                    }}
                  >
                    {Object.keys(tableView).length > 0 ? (
                      "item" in item &&
                        tableView[item.item.name] &&
                        Array.isArray(tableView[item.item.name]) ? (
                        tableView[item.item.name].map((value, index) => {
                          return (
                            <Chip
                              key={index}
                              className={classes.chip}
                              label={value.name}
                            />
                          );
                        })
                      ) : (
                        <Chip
                          key={index}
                          className={classes.chip}
                          label={item.name}
                        />
                      )
                    ) : (
                      <Chip label={item.name} />
                    )}
                  </Box>
                </TableCell>
                <TableCell style={{ padding: "0" }}>
                  <HPOTerms
                    data={formData[index]}
                    pipeline_class="nanopore"
                    handleChange={(name, value) =>
                      handleHPOTermsChange(name, value, index)
                    }
                  />
                </TableCell>
                <TableCell style={{ textAlign: "center" }}>
                  <FormControlLabel
                    onChange={(event) => {
                      handleCheckbox(event, index);
                    }}
                    checked={formData[index]?.calculate_frequency ?? true}
                    control={<Checkbox name="calculate_frequency" />}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <Box display="flex" width="100%" mt={5}>
        <Button
          variant="outlined"
          color="secondary"
          startIcon={<NavigateBefore />}
          onClick={() => setPhase("init")}
        >
          {t("Back")}
        </Button>
        <Button
          style={{ marginLeft: "auto" }}
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          startIcon={<Save />}
        >
          {t("Submit")}
        </Button>
      </Box>
    </>
  );
}

export default Nanaopore;
